import { Autocomplete, IconButton, InputAdornment, SvgIcon, TextField } from '@mui/material';
import { Airline } from '@aviation/cabinapp-airlinedata-sdk';
import { ReactComponent as PencilIcon } from '../../icons/pencil.svg';
import { LookupItem, clientCodeLabel } from './LookupDialog';

export interface ILookupSelectProps {
    value: Array<LookupItem>;
    options: Array<LookupItem>;
    airlines: Array<Airline>;
    clientCode?: string;
    label?: string;
    variant?: 'standard' | 'outlined';
    onChange: (value: Array<LookupItem>) => void;
    onManage: () => void;
}

const LookupSelect = (props: ILookupSelectProps) => {
    const { value, options, airlines, clientCode, label, variant = 'standard', onChange, onManage } = props;

    // Options of the aircraft's own client are listed first, grouped by client code
    const clientOf = (o: LookupItem) => o.ClientCodes?.includes(clientCode ?? '') ? (clientCode ?? '') : (o.ClientCodes?.[0] ?? '');
    const sorted = [...options].sort((a, b) => {
        const ca = clientOf(a) === clientCode ? 0 : 1;
        const cb = clientOf(b) === clientCode ? 0 : 1;
        return ca - cb || clientOf(a).localeCompare(clientOf(b)) || (a.Name ?? '').localeCompare(b.Name ?? '');
    });

    return (
        <Autocomplete
            fullWidth
            size='small'
            options={sorted}
            value={value[0] ?? null}
            groupBy={(o) => { const c = clientOf(o); return c === '' ? 'Other' : clientCodeLabel(c, airlines); }}
            getOptionLabel={(o) => o.Name ?? ''}
            isOptionEqualToValue={(o, v) => o.Id === v.Id}
            filterOptions={(opts, state) => {
                const term = state.inputValue.trim().toUpperCase();
                if (term === '') return opts;
                return opts.filter(o => (o.Name ?? '').toUpperCase().includes(term)
                    || (o.ClientCodes ?? []).some(c => c.toUpperCase().includes(term) || clientCodeLabel(c, airlines).toUpperCase().includes(term)));
            }}
            onChange={(_, newValue) => onChange(newValue ? [newValue] : [])}
            renderInput={(inputParams) => (
                <TextField {...inputParams} label={label} variant={variant} InputProps={{
                    ...inputParams.InputProps,
                    endAdornment: (
                        <>
                            <InputAdornment position='end'>
                                <IconButton size='small' title='Manage entries' onClick={onManage}>
                                    <SvgIcon component={PencilIcon} inheritViewBox fontSize='small' />
                                </IconButton>
                            </InputAdornment>
                            {inputParams.InputProps.endAdornment}
                        </>
                    )
                }} />
            )}
            sx={{ width: '100%', px: variant === 'standard' ? 1 : 0 }}
        />
    );
};

export default LookupSelect;
